import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FeaturedBig({ item }) {
  const [heroImgErr, setHeroImgErr] = useState(false);
  const navigate = useNavigate();
  const eventId = item?.id || item?._id || "1";

  const scheduleDates = item?.schedule?.dates?.length > 0
    ? item.schedule.dates
    : item?.dateBlock?.date
    ? [item.dateBlock.date]
    : [];
  const scheduleTime = item?.schedule?.time || item?.dateBlock?.time || (item?.date?.includes("·") ? item.date.split("·")[1]?.trim() : item?.time || "");
  const hasSchedule = scheduleDates.length > 0 || scheduleTime || item?.dateFull;

  const currencyINR = (n) => typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n || "—";

  return (
    <div
      className="relative w-full overflow-hidden bg-slate-50 dark:bg-slate-950 cursor-pointer min-h-[400px] h-auto md:h-[480px] lg:h-[520px] transition-colors"
      onClick={() => navigate(`/events/${eventId}`)}
    >
      {/* Background with Blur and Light Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-60 blur-3xl scale-110"
        style={{ backgroundImage: `url(${item.image})` }}
      ></div>
      <div className="absolute inset-0 bg-white/60 dark:bg-slate-950/70 transition-colors"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 dark:from-slate-950 dark:via-slate-950/80 to-transparent transition-colors"></div>
      
      {/* Seamless fade to white/dark at the bottom */}
      <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-white via-white/80 dark:from-slate-950 dark:via-slate-950/80 to-transparent transition-colors"></div>

      {/* Content Container — extra side padding keeps text clear of carousel arrows on zoom */}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col items-center justify-between gap-8 px-6 py-10 md:flex-row md:gap-4 md:px-16 md:py-0 lg:px-24 xl:px-28">
        
        {/* Text Details */}
        <div className="order-2 flex w-full flex-col items-center justify-center text-center md:order-1 md:w-3/5 md:items-start md:pr-4 md:text-left lg:w-1/2">
          
          {hasSchedule && (
            <div className="mb-3 text-sm font-bold tracking-wide text-slate-800 dark:text-amber-500 md:text-base transition-colors">
              {scheduleDates[0] || item?.dateFull?.split("•")[0]?.trim()}
              {scheduleTime && `, ${scheduleTime}`}
            </div>
          )}

          <h2 className="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 dark:text-white sm:text-4xl lg:text-5xl transition-colors">
            {item.title}
          </h2>
          
          {(item.subtitle || item.location) && (
            <div className="mb-6 text-lg font-bold text-slate-800 dark:text-slate-300 md:text-xl transition-colors">
              {item.subtitle || item.location}
            </div>
          )}

          <div className="mb-6">
            <div className="text-sm font-bold text-slate-900 dark:text-slate-200 transition-colors">
              {item.price === 0 ? "Free Entry" : `${currencyINR(item.price)} onwards`}
            </div>
          </div>

          <div className="flex items-center justify-center md:justify-start">
            {item?.canBook !== false && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/events/${eventId}`);
                }}
                className="rounded-xl bg-slate-900 dark:bg-amber-500 px-8 py-3.5 font-bold text-white dark:text-slate-950 shadow-lg transition-colors hover:bg-slate-800 dark:hover:bg-amber-400"
              >
                Book tickets
              </button>
            )}
          </div>
        </div>

        {/* Right Side: Image */}
        <div className="flex w-full order-1 md:order-2 md:w-2/5 lg:w-1/2 md:justify-end items-center justify-center mt-6 md:mt-0">
          <div className="aspect-[2/3] w-[200px] md:w-[260px] lg:w-[320px] overflow-hidden rounded-2xl shadow-2xl bg-slate-200 dark:bg-slate-800 transition-colors">
            {item.image && !heroImgErr ? (
              <img
                src={item.image}
                alt={item.title ? `${item.title} poster` : "Event poster"}
                className="h-full w-full object-cover"
                onError={() => setHeroImgErr(true)}
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center text-sm text-slate-500 font-medium">
                Poster unavailable
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
